import {
    REPORT_PLANT_FILTER,
    REPORT_LOCATIONTYPE_FILTER,
    REPORT_PRODUCT_FILTER,
    REPORT_STARTDATE_FILTER,
    REPORT_ENDDATE_FILTER,
    REPORT_TYPE_FILTER,
    REPORT_BILLING_TYPE_FILTER,
    REPORT_MOVEMENT_TYPE_FILTER,
    REPORT_FROM_PLANT_FILTER,
    REPORT_TO_PLANT_FILTER,
    REPORT_UNIT_FILTER,
    REPORT_COPY_ORIGINAL_SELECTED,
    REPORT_SEARCH_TRIGGER,
} from '../constants/ActionTypes';

let bm = new Date();
// bm.setMonth(bm.getMonth() - 3);
bm.setMonth(bm.getMonth());
let intYear = bm.getFullYear();
let intMonth = (bm.getMonth() + 1);
let intDay = bm.getDate();
let defaultStartDate = `${intYear}-${String(intMonth).padStart(2, '0')}-${String(intDay).padStart(2, '0')}`
let defaultEndDate = `${intYear}-${String(intMonth).padStart(2, '0')}-${String(intDay).padStart(2, '0')}`

const initialState = {
    plantSelected: "",
    locationTypeSelected: "",
    // locationTypeSelected: { Code: 'NOR', Name: 'คลังดี', Type: 'LocationType' },
    productSelected: "",
    startDateSelected: defaultStartDate,
    endDateSelected: defaultEndDate,
    // typeSelected: { Name: "รวมคลัง", Code: 'AllPlant' },
    typeSelected: { Name: "แยกคลัง", Code: 'ByPlant' },
    typeBillingSelected: { Name: "แสดงรายการขาย", Code: 'Order' },
    typeMovementSelected: "",
    plantFromSelected: "",
    plantToSelected: "",
    unitSelected: { Name: "หน่วยใหญ่", Code: 'L' },
    copyOriginalSelected: "",
    searchTrigger: 1  // เริ่มต้นที่ 1 เพื่อดึงข้อมูลครั้งแรก (ยกเว้นหน้าที่มีปุ่มค้นหา)
}

export default (state = initialState, action) => {
    switch (action.type) {
        case REPORT_PLANT_FILTER:
            return {
                ...state,
                plantSelected: action.payload,
            }
        case REPORT_LOCATIONTYPE_FILTER:
            return {
                ...state,
                locationTypeSelected: action.payload,
            }
        case REPORT_PRODUCT_FILTER:
            return {
                ...state,
                productSelected: action.payload,
            }
        case REPORT_STARTDATE_FILTER:
            return {
                ...state,
                startDateSelected: action.payload,
            }
        case REPORT_ENDDATE_FILTER:
            return {
                ...state,
                endDateSelected: action.payload,
            }
        case REPORT_TYPE_FILTER:
            return {
                ...state,
                typeSelected: action.payload,
            }
        case REPORT_BILLING_TYPE_FILTER:
            return {
                ...state,
                typeBillingSelected: action.payload,
            }
        case REPORT_MOVEMENT_TYPE_FILTER:
            return {
                ...state,
                typeMovementSelected: action.payload,
            }
        case REPORT_FROM_PLANT_FILTER:
            return {
                ...state,
                plantFromSelected: action.payload,
            }
        case REPORT_TO_PLANT_FILTER:
            return {
                ...state,
                plantToSelected: action.payload,
            }
        case REPORT_UNIT_FILTER:
            return {
                ...state,
                unitSelected: action.payload,
            }
        case REPORT_COPY_ORIGINAL_SELECTED:
            return {
                ...state,
                copyOriginalSelected: action.payload,
            }
        case REPORT_SEARCH_TRIGGER:
            return {
                ...state,
                searchTrigger: action.payload,
            }
        default:
            return state;
    }
}